import { Component, computed, effect, inject, input, output, signal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { type DeviceData, type ModelActionPoint } from '@devices/models';
import { DeviceService } from '@devices/services';
import { NotificationsService, TableSearchInputComponent } from '@ui';
import { finalize } from 'rxjs';

@Component({
  imports: [
    TableSearchInputComponent,
    MatIcon,
  ],
  selector: 'avs-action-point-picker',
  templateUrl: './action-point-picker.component.html',
})
export class ActionPointPickerComponent {
  deviceId = input.required<string>();
  actionPointId = input<string>();
  protected actionPointsList = signal<ModelActionPoint[]>([]);
  protected searchValue = signal('');
  protected selectedPoint = signal('');
  protected filteredActionPointsList = computed(() => {
    return this.actionPointsList().filter(actionPoint => actionPoint.name.toLowerCase().includes(this.searchValue().toLowerCase()));
  });
  protected actionPointSelected = output<ModelActionPoint>();
  protected actionPointsListLoading = false;
  private deviceService = inject(DeviceService);
  private notificationService = inject(NotificationsService);


  constructor() {
    effect(() => {
      this.retrieveActionPointList();
    });
  }

  retrieveActionPointList() {
    this.actionPointsListLoading = true;
    this.selectedPoint.set('');
    this.deviceService.getDeviceDetailsByDeviceId(this.deviceId())
      .pipe(finalize(() => this.actionPointsListLoading = false))
      .subscribe({
        error: (error) => {
          this.notificationService.showErrorMessage(error.message);
        },
        next: (device: DeviceData) => {
          this.actionPointsList.set(device.actionPoints || []);
          if (this.actionPointId() && this.actionPointsList().length) {
            this.selectedPoint.set(this.actionPointId() || '');
            const selectedActionPoint = this.actionPointsList().find(
              actionPoint => actionPoint.deviceActionPointsId === this.actionPointId(),
            );

            if (selectedActionPoint) {
              this.actionPointSelected.emit(selectedActionPoint);
            }
          }
        },
      });
  }

  protected selectActionPoint(point: ModelActionPoint) {
    this.actionPointSelected.emit(point);
    this.selectedPoint.set(point.deviceActionPointsId);
  }
}
